import React, { useState } from 'react';
import { Helmet } from "react-helmet";

const servicesData = [
  {
    title: "Electrical Services",
    description: "At Milstone Associates, our electrical solutions are built upon years of industry expertise and a passion for innovation. From complex electrical infrastructures to efficient lighting systems, our team ensures every project meets the highest standards of safety and performance.",
    image: "/images/electrical.webp",
    features: ["Power Distribution Systems", "Lighting Design", "Electrical Safety", "Energy Efficiency"]
  },
  {
    title: "Mechanical Services",
    description: "At Milstone Associates, our mechanical solutions encompass a wide range of services. Our expertise extends to the design and implementation of HVAC systems, industrial machinery, and more. We are dedicated to ensuring optimal performance and reliability in all our mechanical projects.",
    image: "/images/mechanical.webp",
    features: ["HVAC Systems", "Industrial Machinery", "Mechanical Design", "System Optimization"]
  },
  {
    title: "Plumbing Services",
    description: "Milstone Associates' plumbing services are designed to provide you with top-quality plumbing solutions. Our team handles everything from pipe design of advanced water treatment systems. We prioritize efficiency and sustainability in all our plumbing projects.",
    image: "/images/plumbing.webp",
    features: ["Water Supply Systems", "Drainage Systems", "Water Treatment", "Sustainable Solutions"]
  },
  {
    title: "Fire Suppression",
    description: "Our fire suppression services are designed to protect your property and ensure the safety of occupants. We implement advanced fire detection and suppression systems that meet international safety standards.",
    image: "/images/fire-suppression.webp",
    features: ["Fire Detection Systems", "Sprinkler Systems", "Safety Compliance", "Emergency Planning"]
  },
  {
    title: "Ventilation Systems",
    description: "Our ventilation systems are designed to maintain optimal air quality and comfort in your space. We focus on energy-efficient solutions that promote health and well-being.",
    image: "/images/ventilation.webp",
    features: ["Air Quality Management", "Energy Efficiency", "Comfort Control", "Health Standards"]
  },
  {
    title: "HVAC Services",
    description: "Our HVAC (Heating, Ventilation, and Air Conditioning) services are a cornerstone of Milstone Associates' offerings. We excel in designing HVAC systems that provide optimal indoor comfort and air quality. Our expertise ensures energy-efficient solutions that keep your environment at its best.",
    image: "/images/mechanical.webp",
    features: ["Heating Systems", "Cooling Systems", "Air Conditioning", "Climate Control"]
  }
];

export default function ServicesPage() {
  const [selectedService, setSelectedService] = useState(servicesData[4]);
  return (
    <>
      <Helmet>
        <title>Services | Milstone Associates</title>
        <meta name="description" content="Explore Milstone Associates' comprehensive MEP services including mechanical, electrical, plumbing, and fire suppression solutions." />
        <meta property="og:title" content="Services | Milstone Associates" />
        <meta property="og:description" content="Explore Milstone Associates' comprehensive MEP services including mechanical, electrical, plumbing, and fire suppression solutions." />
        <meta property="og:image" content="/images/logo.webp" />
        <meta property="og:type" content="website" />
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "What MEP services does Milstone Associates provide?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Milstone Associates provides comprehensive MEP services including electrical, mechanical, plumbing, fire suppression, ventilation, and HVAC services for commercial and industrial projects."
                }
              },
              {
                "@type": "Question",
                "name": "Where does Milstone Associates operate?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Milstone Associates operates throughout Pakistan, providing MEP design, engineering, and supervision services to clients across the country."
                }
              },
              {
                "@type": "Question",
                "name": "How can I contact Milstone Associates?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "You can contact Milstone Associates by phone at +92 320 1111444, email at info@milestoneassociate.com, or through our contact form on the website."
                }
              }
            ]
          }
        `}</script>
      </Helmet>
      <div className="w-full min-h-screen px-12 pt-20 pb-6">
        {/* Page Heading */}
        <h1 className="text-4xl font-bold text-center text-black my-10">Our Services</h1>

        <div className="flex flex-col md:flex-row w-full">
          {/* Sidebar */}
          <div className="w-full md:w-1/4 space-y-2 mb-4 md:mb-0">
            {servicesData.map((service) => (
              <button
                key={service.title}
                onClick={() => setSelectedService(service)}
                className={`w-full py-3 px-4 text-left rounded border transition hover:bg-black hover:text-white ${
                  selectedService.title === service.title ? "bg-gray-200 font-semibold" : "bg-gray-50"
                }`}
              >
                {service.title}
              </button>
            ))}
          </div>

          {/* Main content */}
          <div className="w-full md:w-3/4 md:pl-8">
            <h2 className="text-3xl font-bold mb-4">{selectedService.title}</h2>

            <div className="mb-6 rounded overflow-hidden shadow">
              <img
                src={selectedService.image}
                alt={selectedService.title}
                className="w-full h-96 object-cover"
              />
            </div>

            <p className="text-gray-700 text-lg mb-6">{selectedService.description}</p>

            {selectedService.extras && (
              <div>
                <h3 className="text-xl font-semibold mb-2">Expanding Our Offerings</h3>
                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                  {selectedService.extras.map((item) => (
                    <li key={item} className="flex items-center gap-2">
                      <span className="w-4 h-4 bg-gray-600 inline-block"></span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

